import { watch } from '@vue/composition-api';
import { useVSFContext } from '@vue-storefront/core';
import useGoogleAnalytics, { eventBuilder } from '~/hooks/useGoogleAnalytics';
import { PLP_PRODUCTS_PER_PAGE } from '~/helpers/constants';
import type { Ref } from '@vue/composition-api';

type VSFContext = ReturnType<typeof useVSFContext>

export function useProductListingAnalytics(
  products: Ref<any[]>,
  pageCurrent: Ref<number>,
  vsfContext: VSFContext
): void {
  const { registerEvent } = useGoogleAnalytics({
    onMountedEvents: [
      eventBuilder('productImpression')({
        products: products.value,
        skippedProductsCount: (pageCurrent.value - 1) * PLP_PRODUCTS_PER_PAGE,
        vsfContext
      })
    ]
  });

  function registerProductImpression(prods: any[], page: number) {
    registerEvent(
      eventBuilder('productImpression')({
        products: prods,
        skippedProductsCount: (page - 1) * PLP_PRODUCTS_PER_PAGE,
        vsfContext
      })
    );
  }

  // watch for changes
  watch(products, (newProducts) => {
    if (!newProducts?.length) return;

    registerProductImpression(newProducts, pageCurrent.value);
  });
}
